module.exports = __webpack_public_path__ + "img/img5.df44cea6.jpg";